import { render } from "./datatablerowbuttons.vue?vue&type=template&id=d3f77dd0&scoped=true"
import script from "./datatablerowbuttons.vue?vue&type=script&lang=ts"
export * from "./datatablerowbuttons.vue?vue&type=script&lang=ts"

import "./datatablerowbuttons.vue?vue&type=style&index=0&id=d3f77dd0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d3f77dd0"

export default script